export default {
  label: "Security Center",
  tabs: {
    dashboard: {
      label: "Dashboard",
      activeVulnerabilities: "Active Vulnerabilities",
      statCards: {
        activeLabel: "Active",
        loadError: "Failed to load vulnerability stats. Please try again.",
      },
      trendChart: {
        title: "Vulnerabilities by Severity Over Time",
        lastMonths: "Last {count} months",
      },
      resolutionChart: {
        title: "Average Time to Resolve a CVE",
        statusNew: "New",
        statusUnderInvestigation: "Under Investigation",
      },
      affectedResourcesWidget: {
        title: "Affected Resources",
        devices: "Devices",
        deploymentGroups: "Deployment Groups",
        softwareRevisions: "Software Revisions",
        viewAll: "View All",
      },
    },
    vulnerabilities: {
      label: "Vulnerabilities",
      scanInfo: "Scan information: Public CVE databases were last queried on {date} (UTC).",
      // ── Filter Section ──
      filters: {
        title: "Filter CVEs",
        hideFilters: "Hide filters",
        showFilters: "Show filters",
        clickToFilter: "(*Click to filter)",
        byStatus: "By status",
        bySeverity: "By severity",
        byCvssScore: "By CVSS score",
        byDevices: "By devices",
        byDeploymentGroups: "By deployment groups",
        bySoftwares: "By softwares",
        selectDevices: "SELECT DEVICES",
        editDevices: "EDIT DEVICES",
        filterByDevices: "Filter by devices",
        filterByDeploymentGroups: "Filter by deployment groups",
        selectDeploymentGroups: "SELECT DEPLOYMENT GROUPS",
        editDeploymentGroups: "EDIT DEPLOYMENT GROUPS",
        selectSoftwares: "SELECT APPS",
        editSoftwares: "EDIT APPS",
        chartsFailedToLoad: "Charts could not be loaded. Please check your connection and try again.",
        retry: "Retry",
        filterBySoftwares: "Filter by softwares",
        clearAllFilters: "Clear all filters",
        clearFilter: "Clear filter",
        activeFilters: "{count} Active",
      },
      // ── CVE List ──
      cveList: {
        title: "CVE list",
        changeStatus: "Change status",
        changeStatusTooltipDisabled: "Select CVEs to change status",
        searchPlaceholder: "Search CVEs…",
        activelyExploited: "Actively Exploited",
        emptyState: "No vulnerabilities found",
        emptyStateFiltered: "No CVEs match the current filters",
        columns: {
          cveId: "CVE ID",
          title: "Title",
          scanDate: "Scan Date",
          status: "Status",
          severity: "Severity",
          cvssScore: "CVSS Score",
          component: "Library",
          software: "Software",
          softwareVersion: "Software Version",
        },
        pagination: {
          rowsPerPage: "Rows per page:",
        },
      },
      // ── Statuses ──
      statuses: {
        new: "New",
        underInvestigation: "Under Investigation",
        notAffected: "Not Affected",
        affected: "Affected",
        fixed: "Fixed",
      },
      // ── Severity ──
      severity: {
        critical: "Critical",
        high: "High",
        medium: "Medium",
        low: "Low",
      },
      // ── Security Cell (table column) ──
      securityCell: {
        columnHeader: "Vulnerabilities",
        tooltipCritical: "Critical: {count}",
        tooltipHigh: "High: {count}",
        tooltipLastScanned: "Last scanned: {date}",
        tooltipNoScanData: "No scan data available",
        tooltipViewInSecurityCenter: "View in security center",
        noVulnerabilities: "0",
      },
      // ── CVE Detail Page ──
      detailPage: {
        back: "Back to vulnerability management overview",
        notFound: "Vulnerability not found.",
        header: {
          activelyExploited: "Actively Exploited",
          epssLabel: "EPSS",
          epssTooltip: "Exploit Prediction Scoring System — probability of exploitation in the wild",
          cvssVector: "CVSS v3 Vector",
          noScore: "N/A",
          sources: "Sources",
        },
        meta: {
          published: "NVD Published Date",
          nvdLastModified: "NVD Last Modified",
          detected: "First Detected",
          cwe: "CWE",
          source: "Source",
          cvssScore: "CVSS Score",
          severity: "Severity",
          status: "Status",
          devices: "Devices",
          components: "Components",
          viewOnNvd: "View on NVD",
          nvdLinkText: "You can view the official entry here:",
          unknown: "Unknown",
        },
        sections: {
          description: "Description",
          cveDescription: "CVE Description",
          remediation: "Remediation Guidance",
          cveUpdates: "CVE updates",
          affectedComponents: "Affected Components ({count})",
          noDescription: "No description available.",
          noRemediation: "No remediation guidance available.",
          tabs: {
            cveUpdates: "CVE updates",
            cveDescription: "CVE description",
            affectedResources: "Affected Resources",
          },
          matrix: {
            vulnerabilityDetails: "Vulnerability Details",
            severityScoring: "Severity & Scoring",
            affectedResources: "Affected resources",
          },
        },
        componentsTable: {
          componentName: "Component",
          componentVersion: "Version",
          componentPurl: "PURL",
          softwareRevision: "Software Revision",
          componentType: "Type",
          status: "Status",
          actions: "Actions",
          changeStatus: "Change Status",
          viewHistory: "View History",
          library: "Library",
          platformComponent: "Platform Component",
          noFindings: "No affected components found.",
        },
        statusChange: {
          title: "Change Status — {component}",
          successToast: "Status updated successfully",
        },
        statusHistory: {
          title: "Status History — {component}",
          noHistory: "No status changes recorded yet.",
          by: "by {user}",
          byUnknown: "by unknown user",
          arrowLabel: "→",
        },
        cveActivity: {
          updateCve: "UPDATE CVE",
          statusChangedTo: "Status changed to",
          statusLabel: "Status",
          system: "System",
          createdOn: "created this record on {date}.",
          unknownUser: "Unknown user",
          noActivity: "No activity recorded yet.",
        },
      },
      // ── Change Status Modal ──
      changeStatusModal: {
        titleSingle: "Change Status - {cveId}",
        titleBulk: "Change Status - {count} CVEs",
        addComment: "Add a comment",
        commentRequired: "Comment is required",
        commentMaxLength: "{count}/300",
        close: "CLOSE",
        save: "SAVE",
        statusDescriptions: {
          new: "The CVE has been detected but not yet reviewed or assessed.",
          underInvestigation: "The impact of the vulnerability on the product is unknown, pending further analysis.",
          notAffected:
            "After investigation, the vulnerability has been confirmed to be not exploitable in the product.",
          affected: "The vulnerability is exploitable in the product and poses a security risk.",
          fixed: "A new version of the product containing the fix for the vulnerability has been released.",
        },
      },
      // ── Affected Resources ──
      affectedResources: {
        title: "Affected resources",
        subtitle: "Resources affected by selected or filtered CVEs",
        noData: "No data found",
        tabs: {
          devices: "DEVICES",
          deploymentGroups: "DEPLOYMENT GROUPS",
          softwares: "APPS",
        },
        devicesColumns: {
          serialNumber: "Device Serial Number",
          modelVersion: "Model & Version",
          asset: "Asset",
          lastStoreContact: "Last Store Contact",
          deploymentGroup: "Deployment Groups",
          tags: "Tags",
        },
        deploymentGroupsColumns: {
          name: "Deployment Group",
          architecture: "Architecture",
          deviceModel: "Device Model",
          deviceCount: "Amount of Devices",
          criticalVulnCount: "Critical CVEs",
          highVulnCount: "High CVEs",
        },
        softwaresColumns: {
          softwareName: "Software Name",
          version: "Version",
          status: "Status",
          usage: "Usage",
        },
      },
    },
  },
};
